import { ON_PSA_MAIN_PRODUCT_ADDED } from '../components/PSAPopup/PSAPopup';

export const triggerMainProductAddedEvent = (
  fupid,
  basketRedirectUrl,
  storeId = null,
  deliveryType = null,
  mainProductId = null,
  mainProductSegmentId,
  addonProductsIds = null,
  addonProductsNames = null,
  addonProductsSegmentIds = null,
  bundlePrice = null
) => {
  const onPSAMainProductAdded = new CustomEvent(ON_PSA_MAIN_PRODUCT_ADDED, {
    detail: {
      fupid,
      basketRedirectUrl,
      storeId,
      deliveryType,
      mainProductId,
      mainProductSegmentId,
      addonProductsIds,
      addonProductsNames,
      addonProductsSegmentIds,
      bundlePrice
    }
  });
  document.dispatchEvent(onPSAMainProductAdded);
};
